import "./pagination.css";

interface PaginationProps {
  currentPage: any;
  setCurrentPage: any;
  questionsPerPage: any;
  questionsLog: any;
}

export const Pagination = ({
  currentPage,
  setCurrentPage,
  questionsPerPage,
  questionsLog,
}: PaginationProps) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 0; i < totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => goToPage(i)}
          className={i === currentPage ? "active" : ""}
        >
          {i + 1}
        </button>
      );
    }
    return pageNumbers;
  };

  const totalPages = Math.ceil(questionsLog.length / questionsPerPage);

  const goToPage = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  const goToNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage((prev: number) => prev + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prev: number) => prev - 1);
    }
  };

  return (
    <div className="paginationControls">
      <button
        onClick={goToPreviousPage}
        disabled={currentPage === 0}
      >
        <svg
          fill={currentPage === 0 ? "#C1C7CC" : ""}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
        >
          <path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z" />
        </svg>
      </button>

      {renderPageNumbers()}

      <button
        onClick={goToNextPage}
        disabled={currentPage === totalPages - 1}
      >
        <svg
          fill={currentPage === totalPages - 1 ? "#C1C7CC" : ""}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
        >
          <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
        </svg>
      </button>
    </div>
  );
};
